import { Component, OnInit, Input } from '@angular/core';
import { ShippingMethod } from '@pages/checkout-app/types';
@Component({
  selector: 'display-delivery-promise',
  styles: ['.font12 { font-size: 12px;}'],
  template: `
    @if (deliveryPromiseData.displayEstimatedDeliveryBusinessDays || deliveryPromiseData.displayEstDelivery) {
      <pdq-button [plain]="true" (onClick)="showDeliveryPromise = !showDeliveryPromise">{{
        showDeliveryPromise ? 'Hide delivery promise' : 'Show delivery promise'
      }}</pdq-button>
      @if (showDeliveryPromise) {
        <div class="col gap font12">
          {{ isLiveRateMethod ? 'Processing time' : 'Delivery promise settings' }}
          @if (deliveryPromiseData.estimatedTimeConversions) {
            <div>
              @switch (deliveryPromiseData.estimatedTimeConversions) {
                @case ('live') {
                  <div>Est Delivery: dynamic by live rate</div>
                }
                @case ('manual') {
                  <div>Manualy estimated time</div>
                }
                @case ('pdqiq') {
                  <div>Est Delivery: dynamic by PDQ IQ</div>
                }
              }
            </div>
          }
          @if (deliveryPromiseData.displayEstimatedDeliveryBusinessDays || deliveryPromiseData.displayEstDelivery) {
            @if (deliveryPromiseData.displayEstimatedDeliveryBusinessDays) {
              <div>show delivery time</div>
            }
            @if (deliveryPromiseData.displayEstDelivery) {
              <div>Show delivery date range,</div>
            }
            <div>{{ deliveryPromiseData.displayDeliveryPromiseText }}</div>
          }
        </div>
      }
    }
  `,
  standalone: false,
})
export class DisplayDeliveryPromiseComponent implements OnInit {
  @Input() shipping;
  deliveryPromiseData: any = {};
  showDeliveryPromise = false;
  isLiveRateMethod = false;

  constructor() {}

  ngOnInit() {
    const { displayEstimatedDeliveryBusinessDays, displayEstDelivery, shippingMethod, estimatedTimeConversions } =
      this.shipping;
    const { minDays, maxDays, minHours, maxHours, category } = shippingMethod;
    this.isLiveRateMethod = [ShippingMethod.DOMESTIC_LIVE_RATE, ShippingMethod.INTERNATIONAL_LIVE_RATE].includes(
      category,
    );

    let type: string = 'days';
    let displayDeliveryPromiseText = '';
    let min = minDays ?? 0;
    let max = maxDays ?? 0;
    if (category === ShippingMethod.LOCAL) {
      type = 'hours';
      min = minHours ?? 0;
      max = maxHours ?? 0;
    }

    if (min === max || (min == 0 && max == 0)) {
      displayDeliveryPromiseText = `Est delivery: ${min} ${type}`;
    } else {
      displayDeliveryPromiseText = `${min} to ${max} ${type}`;
    }
    this.deliveryPromiseData = {
      displayDeliveryPromiseText,
      displayEstDelivery,
      displayEstimatedDeliveryBusinessDays,
      estimatedTimeConversions,
    };
  }
}
